import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'semantic-ui-react'
import * as R from 'ramda'
import leftPad from 'left-pad'

const timeOptions = R.map(
  R.compose(
    (time) => ({ key: time, text: time, value: `${time}:00`, icon: 'clock' }),
    (time) => `${leftPad(time, 2, 0)}:00`
  )
)(R.range(0, 24))

export const TimeDropdown = ({ onChange, defaultValue }) => (
  <Dropdown
    selection
    defaultValue={defaultValue || timeOptions[0].value}
    options={timeOptions}
    onChange={(_, { value }) => onChange(value)}
  />
)

TimeDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
}

TimeDropdown.defaultProps = {
  onChange: () => {},
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/TimeDropdown/index.js